import React from 'react';
import {Link} from 'react-router-dom'
function Index() {
  return (
    <div className="index">
        <ul>
            <li className='yiyu'><Link to="/sds">抑郁自评量表（SDS）</Link></li>
            <li className='jiaolv'><Link to="/sas">焦虑自评量表（SAS）</Link></li>
        </ul>
    </div>
  );
}

export default Index;
